import { Injectable } from '@angular/core';
import {
  Observable,
  throwError,
  of,
  BehaviorSubject,
  catchError,
  map,
} from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { SharedService } from './shared.service';
import { GenericClass } from '../interfaces';
import { UserInfo, CompanyInfo, AuthToken } from '../interfaces';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class UserInfoService {
  constructor() {}
  _info: any = null;
  jwtToken: any = null;
  companyinfo: any = null;
  userPermissions: any = {};
  observableUserInfo = new BehaviorSubject<any[]>(this._info);
  observablecompanySettings = new BehaviorSubject<any[]>(this.companyinfo);

  get() {
    return this._info || {};
  }

  set(info: UserInfo) {
    this._info = info;
    this.setUserPermissions();
  }

  reset() {
    this._info = null;
    this.companyinfo = null;
    this.authToken.clear();
  }

  setCompanyDetails(companyinfo: CompanyInfo) {
    this.companyinfo = companyinfo;
    this.observablecompanySettings.next(this.companyinfo);
  }

  getPermissions() {
    return this.userPermissions || {};
  }

  setUserPermissions() {
    if (this._info.permissions && this._info.permissions.length > 0) {
      let currPermission: string = '';
      let userAllowedPermissionsList: string = this._info.permissions
        .join()
        .toLowerCase()
        .split(',');

      for (let key in GenericClass.permissionObj) {
        currPermission = GenericClass.permissionObj[key].toLowerCase();
        this.userPermissions[key] = false;

        if (userAllowedPermissionsList.includes(currPermission)) {
          this.userPermissions[key] = true;
        }
      }
    }

    this.observableUserInfo.next(this._info);
  }

  authToken: AuthToken = {
    _token: null,
    set: function (token: string) {
      GenericClass.setCookie('id_token', token, 7);
      this._token = token;
    },
    get: function () {
      if (GenericClass.getCookie('id_token') && !this._token) {
        this._token = GenericClass.getCookie('id_token');
      }
      return GenericClass.getCookie('id_token');
    },
    clear: function () {
      GenericClass.deleteCookie('id_token');
      this._token = null;
    },
    isSet: function () {
      return this.get() ? true : false;
    },
  };
}

@Injectable({
  providedIn: 'root',
})
export class GetToken {
  constructor(
    private http: HttpClient,
    private userInfoService: UserInfoService,
    private router: Router,
    private sharedService: SharedService,
    private apiService: ApiService
  ) {}

  fetchUserToken(
    token: string,
    companycode: string,
    previousCompanyCode?: string
  ): Observable<any> {
    return this.apiService.getUserInfo<any>(token, companycode).pipe(
      map((response: any) => {
        let sfrefreshtoken = this.sharedService.getCookie('sfrefreshtoken');
        let sfaccesstoken = this.sharedService.getCookie('sfaccesstoken');
        let userData: any = JSON.parse(JSON.stringify(response.data));

        if (userData.jobRocketClientUrl) {
          userData.jobRocketClientLoginUrl = userData.jobRocketClientUrl;
          userData.jobRocketClientUrl = userData.jobRocketClientUrl.replace(
            'account/login',
            ''
          );
        }
        if (sfrefreshtoken) {
          userData.sfrefreshtoken = sfrefreshtoken;
        }
        if (sfaccesstoken) {
          userData.sfaccesstoken = sfaccesstoken;
        }

        this.userInfoService.set(userData);
        this.sharedService.loggedInUser = JSON.parse(JSON.stringify(userData));

        if (!previousCompanyCode || previousCompanyCode !== companycode) {
          if (companycode) {
            GenericClass.setCookie('companycode', companycode, 7);
          }
        }
        GenericClass.setCookie('primaryColor', userData.color1, 7);
        GenericClass.setCookie('secondaryColor', userData.color2, 7);

        return userData; // Return userData for consistency
      }),
      catchError(error => {
        const errorBody = error?.error?.error ?? error?.error ?? {};
        const message =
          typeof errorBody === 'object' && errorBody !== null
            ? { ...errorBody }
            : { message: String(errorBody) };
        if (error.status === 501 && message.message === 'Not allowed') {
          message.message =
            'This is not a dead end. Looks like you tried to open a page which is not shared with you by company admin.';
          message['message1'] =
            'Please get the required access from company admin and try again.';
          this.sharedService.setErrorMessage(message);
          this.router.navigate(['error']);
          return of(false); // Return false as an Observable
        }
        return throwError(() => error);
      })
    );
  }
}
